/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Peter Y (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Icon from "@mui/material/Icon";
import { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MDTypography from "components/MDTypography";


export default function data(list, deleteList, editList) {
  console.log("list: ", list);
  const [menu, setMenu] = useState({});

  const openMenu = ({currentTarget}, i) => {
    const updateMenu = {...menu};
    updateMenu[`key-${i}`] = currentTarget;
    setMenu(updateMenu);
  }

  const closeMenu = (i) => {
    const updateMenu = {...menu};
    updateMenu[`key-${i}`] = null;
    setMenu(updateMenu);
  }

  const deleteItem = (i)=>{
    const item = list[i]
    deleteList(item.pk);
    closeMenu(i);
  }

  const editItem = (i, flag) => {
    editList(i, flag);
    closeMenu(i);
  }

  const renderMenu = (i) => (
    <Menu
      id="alarm-menu"
      anchorEl={menu[`key-${i}`]}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(menu[`key-${i}`])}
      onClose={()=>closeMenu(i)}
    >
      <MenuItem onClick={()=>editItem(i)}>Edit</MenuItem>
      <MenuItem onClick={()=>editItem(i,  true)}>Duplicate</MenuItem>
      <MenuItem onClick={()=>closeMenu(i)}>Disable</MenuItem>
      <MenuItem onClick={()=>deleteItem(i)}>Delete</MenuItem>
    </Menu>
  );



  return {
    columns: [
      { Header: "Name", accessor: "name", align: "left" },
      { Header: "Description", accessor: "description", align: "left" },
      { Header: "Created At", accessor: "created_at", align: "left" },
      { Header: "status", accessor: "status", align: "center" },
      { Header: "action", accessor: "action", align: "center" },
    ],

    rows: list.map((item, i) =>
    (
      {        
        name: (
          <MDTypography component="a" href="#" variant="button" color="text" fontWeight="medium">
            {item.name}
          </MDTypography>
        ),
        description: (
          <MDTypography component="a" href="#" variant="button" color="text" fontWeight="medium">
            {item.description}
          </MDTypography>
        ),
        created_at: (
          <MDTypography component="a" href="#" variant="button" color="text" fontWeight="medium">
            {item.created_at}
          </MDTypography>
        ),
       
        status: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            active
          </MDTypography>
        ),
        action: (
          <MDTypography component="a" href="#" color="text">
            <Icon onClick={(target)=>openMenu(target, i)}>more_vert</Icon>
            {renderMenu(i)}
          </MDTypography>
        ),
      }      
    )
    )



  };
}
